<template>
	<div style="margin-top: 5px;">
		<li>
			<span class="spanlabel">总计：</span>
			<span class="spantxt">￥{{sum}}</span>
		</li>
		<el-row>
			<el-col :span="24" v-for="li in goodslist">
				<div>
					<ul style="float: left;margin: 2px;">
						<li style="width: 100px;height: 100px;">
							<img class="imgsize" :src='"/img"+ li.goods_address' alt="">
						</li>
					</ul>
					<ul style="width: 100%;">
						<li class="lileft">{{li.goods_name}}</li>
						<li class="lileft">
							<span class="spanlabel">单价：￥{{li.goods_saleprice}}</span>
							<span class="spantxt">X{{li.goods_count}}</span>
						</li>
					</ul>
				</div>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	import goods from '../../apifunction/Goods.js'
	export default {
		created() {
			this.userent = this.$myglobal.getUserInfo();
			this.ShowMOrderDetail();
		},
		props: ["inmorderid"],
		data() {
			return {
				morderid: this.inmorderid,
				goodslist: [],
				sum: 0
			}
		},
		methods: {
			ShowMOrderDetail() {
				goods.GetGoodsByMOrderID(this.morderid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.goodslist = JSON.parse(ent.Data);
								this.ShowSum();
							}
						} else
							this.$message.info(ent.Msg);
					})
			},
			ShowSum() {
				this.sum = 0;
				if (this.goodslist.length < 1)
					return;
				let tempsum = 0;
				for (let i = 0; i < this.goodslist.length; i++) {

					tempsum += this.goodslist[i].goods_saleprice * this.goodslist[i].goods_count;

				}
				this.sum = tempsum;
			},
		}

	}
</script>

<style>
</style>
